import React, {useEffect, useState} from 'react';
import { Alert, Input, Row } from 'reactstrap';
import Toggle from './Toggle';
import { useDispatch } from 'react-redux';
import {newNumberOrderList} from '../actions/Provisioning';
import { Button, InputGroup, InputGroupAddon, Col } from 'reactstrap';
import DateRangePicker from "react-bootstrap-daterangepicker";
import Pagination from 'rc-pagination';
import SetLimitEntries from '../components/SetLimitEntries';
import Spinner from './Spinner/Spinner.js';
import filterIcon from '../Res/Icon/filter.png';
import { set } from 'lodash';
import { ENG_LOCALE } from '../lib/constants';

const filterOptions = ['User', 'Date', 'Order number', 'DID'];

const formatDate = (date) => {
  const newDate = new Date(date);
  const month = newDate.getUTCMonth() + 1;
  const day = newDate.getDate();
  const year = newDate.getFullYear();

  return `${month}/${day}/${year}`
}

const initialState = {
  limit: 25,
  page: 1,
  totalDocs: null,
}

const initialSearchState = {
  search: '',
  startDate: '',
  endDate: ''
}

const formatPhoneNumber = (number) => {
  return number.slice(2)
}

const NoData = () => {
  return (
    <tr>
    <td colSpan={12}>
      <Alert rowSpan={12} color="info">
        No data
      </Alert>
    </td>
  </tr>
  )
}

const OrderHistoryList = () => {
   const dispatch = useDispatch();
   const token = localStorage.getItem('jwtToken') || null;

    const [isShowDetails, setIsShowDetails] = useState(false);
    const [data, setData] = useState(null);
    const [selectedRow, setselectedRow] = useState(null);
    const [searchType, setSearchType] = useState('User');
    const [searchTerm, setSearchTerm] = useState(initialSearchState);
    const [paginationOptions, setPaginationOptions] = useState(initialState);
    const [isClear, setIsClear] = useState(false);

    const getData = async (value = {}) => {
      setData(false);

      const data = await dispatch(
        newNumberOrderList(token, { ...paginationOptions, ...searchTerm, searchType, ...value }),
      );

      const { docs, page, limit, totalDocs } = data;
      setData(docs)

      if(!docs.length){
        setSearchTerm(() => ({...initialSearchState}))
        return
      }

      setPaginationOptions((paginationOptions) => ({...paginationOptions, page, limit, totalDocs}))
    };

    useEffect(() => {
      getData()
      .catch(console.error);
  }, [isClear]);

    const handleClick = (orderDetail) => {
      console.log('orderDetail',orderDetail);
      setIsShowDetails(isShowDetails => !isShowDetails)
      setselectedRow(orderDetail)
    }

    const handleBack = () => {
      setIsShowDetails(isShowDetails => !isShowDetails)
    }

    const handleLimit = async (value) => {
      await getData({ limit: value });
    }

    const onSearchHandle = async () => {
      if(!(searchTerm.search || (searchTerm.startDate && searchTerm.endDate))){
        return
      }

      await getData();
    }

    const onDateSelect = (event, picker) => {
      const startDate = picker.startDate.format("YYYY-MM-DD");
      const endDate = picker.endDate.format("YYYY-MM-DD");

      setSearchTerm((searchTerm) => ({...searchTerm, startDate, endDate}));
    }

    const handlePagination = async (currPage, _) => {
      await getData({page: currPage})
    }

    const onClearHandle = () => {
      setSearchTerm(() => (initialSearchState));
      setSearchType(() => ('User'))
      if(!(searchTerm.search || (searchTerm.startDate && searchTerm.endDate)) && data.length){
        return
      }

      setIsClear((isClear) => (!isClear))

    }

    const onSearchInput = (e) => {
      const {value} = e.currentTarget;

      setSearchTerm((searchTerm) => ({...searchTerm, search: value}));
    }

    const onSearchType = (e) => {
      const {value} = e.currentTarget;

      setSearchTerm(() => (initialSearchState));
      setSearchType(() => (value))
    }

    if(!data){
      return (
        <Spinner/>
      )
    }

    return (
      <>{!isShowDetails && (<div className='SearchBar'>
        <Row style={{ width: '40%' }}>
              <Col md={4} sm={12} style={{ paddingRight: '0px' }}>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend" className="filter-icon-div">
                        <img src={filterIcon} className="filter-icon" alt="filter" />
                      </InputGroupAddon>
                      <Input
                        type="select"
                        className="filter-append-dropdown"
                        value={searchType}
                        onChange={onSearchType}
                      >
                        {filterOptions.map(el => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </Input>
                    </InputGroup>
              </Col>
              {searchType === filterOptions[1] ? (
              <Col md={4} sm={12} style={{ paddingRight: '10px' }}>
                <DateRangePicker containerStyles={{ width: '100%'}} onApply={onDateSelect}>
                <input placeholder='Date Range' type="text" className="form-control"  value={`${searchTerm.startDate || 'YYYY-MM-DD'} - ${searchTerm.endDate || 'YYYY-MM-DD'}`} readOnly={true}/>
                </DateRangePicker>
              </Col>
              ) :(<Col md={4} sm={12} style={{ paddingRight: '10px' }}>
                    <Input
                      id="searchTerm"
                      name="searchTerm"
                      placeholder="Search Term"
                      value={searchTerm.search || ''}
                      onChange={onSearchInput}
                    />
              </Col>)}
              <Col md={2} sm={12} style={{ paddingLeft: '0px' }}>
                          <Button type="button" onClick={onSearchHandle} style={{ width: '100%'}}>
                            Search
                          </Button>
              </Col>
              <Col md={2} sm={12} style={{ paddingLeft: '0px' }}>
                          <Button type="button" onClick={onClearHandle} style={{ width: '100%' }}>
                            Clear
                          </Button>
              </Col>
        </Row>
      </div>)}
        <div className="provisionList-container">
        {isShowDetails && (<div className='OrderSummaryContainer'>
          <div>Order Number: {selectedRow.orderNumber}</div>
          <div>By User: {selectedRow?.user?.name || 'N/A'}</div>
          <div>Date: {formatDate(selectedRow.createdAt)}</div>
        </div>)}

        <div className="table-header-fixed provision-table">
          { !isShowDetails && (<table className="provisionList">
            <thead>
              <tr>
                <th>Order Number</th>
                <th>By User</th>
                <th># of DID's Ordered</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {data.length ? (
                data.map((order, idx) => {
                  // const {orderNumber, user:{name}, numberOfDIDOrdered, createdAt} = order;
                   const {orderNumber, user, numberOfDIDOrdered, createdAt} = order;
                  const name = user?.name || 'N/A'
                  return (<tr key={idx} onClick={() => handleClick(order)}>
                    <td>{orderNumber}</td>
                    <td>{name}</td>
                    <td>{numberOfDIDOrdered}</td>
                    <td>{formatDate(createdAt)}</td>
                    </tr>
                  )
                })
              ) : <NoData/>
                }
            </tbody>
          </table>)}
          {isShowDetails && (<table className="provisionList">
          <thead>
            <tr>
              <th>Number</th>
              <th>SMS/MMS</th>
              <th>Route</th>
              <th>Company</th>
              <th>Ordered By</th>
              <th>Temp DID</th>
            </tr>
            </thead>
            <tbody>
              {selectedRow.orderDetails.length ? (
                selectedRow.orderDetails.map((item, idx) => {
                  const {number: {number}, isSMS, isTempDID, route, company: {name} } = item;
                  return (<tr key={idx}>
                    <td>{formatPhoneNumber(number)}</td>
                    <td><Toggle value={isSMS}/></td>
                    <td>{route}</td>
                    <td>{name}</td>
                    <td>{selectedRow?.user?.email || 'N/A'}</td>
                    <td><Input type="checkbox" checked={isTempDID}  onChange={() => {}}/></td>
                    </tr>
                  )

                })
              ): <NoData/>
              }
            </tbody>
          </table>
        )}

          {isShowDetails && (
            <div className='OrderSummaryContainer'>
              <Button
                color="primary"
                outline
                size="lg"
                onClick={() => handleBack()}
              >
                Back
              </Button></div>)}
        </div>
        {data && !isShowDetails && <Row className="justify-content-md-center">
                <SetLimitEntries selectOptions={[25, 50, 100]} onChange={handleLimit}/>
                <Pagination
                  locale={ENG_LOCALE}
                  className="pagination-container"
                  onChange={handlePagination}
                  current={paginationOptions.page}
                  total={paginationOptions.totalDocs}
                  pageSize={parseInt(paginationOptions.limit, 10)}
                  showLessItems
                  showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                />
              </Row>
          }
      </div>
      </>
    )
  }

  export default OrderHistoryList;
